<template>
  <div>
    <v-btn
      color="primary"
      :disabled="disabled"
      :x-large="xLargeButton"
      :large="largeButton"
      :small="smallButton"
      @click="showDialogButtonClickEvent"
    >
      {{ buttonCaption }}
    </v-btn>
    <v-dialog
      v-model="enableDialog"
      persistent
      width="900"
      scrollable
      @keydown.esc="closeDialog"
      @close="closeDialog"
    >
      <v-card flat>
        <v-toolbar flat>
          <v-toolbar-title>
            請求先から選択
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-card flat>
            <v-card-subtitle>
              <v-row class="pt-2">
                <!-- 請求先コード -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="searchForm.code"
                    dense
                    hide-details="auto"
                    label="請求先コード"
                    clearable
                    outlined
                    persistent-placeholder
                    placeholder="例）1234567"
                    rounded
                    @blur="searchBillingAddress"
                    @click:clear="searchForm.code = null; searchButtonClickEvent()"
                  />
                </v-col>
                <!-- 名称 -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="searchForm.name"
                    dense
                    hide-details="auto"
                    label="名称"
                    clearable
                    outlined
                    persistent-placeholder
                    placeholder="部分一致で検索"
                    rounded
                    @blur="searchBillingAddress"
                    @click:clear="searchForm.name = null; searchButtonClickEvent()"
                  />
                </v-col>
                <!-- /名称 -->
              </v-row>
            </v-card-subtitle>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="searchButtonClickEvent"
              >
                <v-icon>mdi-magnify</v-icon>&nbsp;検索
              </v-btn>
            </v-card-actions>
            <v-card-text>
              <v-data-table
                :headers="tableHeaders"
                :items="billing_addresses"
                :items-per-page="-1"
                disable-sort
                single-select
                hide-default-footer
                @click:row="listRowClick"
                @dblclick:row="rowDoubleClickEvent"
              >
                <template v-slot:[`item.code`]="{ item }">
                  <div
                    style="font-size: 90%;"
                  >
                    {{ item.code }}&nbsp;
                  </div>
                </template>
                <!-- 請求先名 -->
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    :title="item.name"
                    class="ellipsis-text float-left"
                    style="max-width: 300px;width: initial;font-size: 90%;"
                  >
                    {{ item.name }}
                  </div>
                </template>
                <!-- /請求先名 -->
                <!-- 住所 -->
                <template v-slot:[`item.address`]="{ item }">
                  <div
                    :title="item.address"
                    class="ellipsis-text"
                    style="max-width: 250px;width: initial;font-size: 85%;"
                  >
                    {{ item.address }}
                  </div>
                </template>
                <!-- /住所 -->
              </v-data-table>
              <v-row dense>
                <v-col>
                  <v-pagination
                    v-model="page"
                    :length="pagination.total_pages"
                    :total-visible="totalVisible"
                    circle
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    @input="pageChangeEvent"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeDialog"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="!choseBillingAddress"
            class="primary"
            @click="registerButtonClickEvent"
          >
            反映
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

/**
 * 請求先選択ダイアログの呼び出し
 * 呼び出し元画面に選択した結果を返します。
 *
 * 呼び出し元は以下のコールバックを定義してください。
 * ・choseBillingAddressCallback
 *  @return billing_address [Object] 請求先
 */
export default {
  name: 'ChooseBillingAddressButton',
  components: {},
  mixins: [],
  props: {
    buttonCaption: {
      type: String,
      default: () => '請求先を選択'
    },
    xLargeButton: {
      type: Boolean,
      default: () => false,
    },
    largeButton: {
      type: Boolean,
      default: () => false,
    },
    smallButton: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    selfTenant: {
      type: Boolean,
      default: () => false,
    },
    exclusionIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      enableDialog: false,
      page: 1,
      totalVisible: 7,
      tableHeaders: [
        { value: 'code', text: '請求先コード', width: '15%' },
        { value: 'name', text: '請求先名', width: '45%' },
        { value: 'address', text: '住所', width: '40%' }
      ],
      billing_addresses: [],
      choseRow: null,
      choseBillingAddress: null,

      searchForm: {
        code: null,
        name: null,
      },
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.scrollToTop()
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterSearchBillingAddressMember', {
      fetchBillingAddressMembers: 'index'
    }),
    /**
     * 請求先ボタン クリックイベント
     */
    showDialogButtonClickEvent () {
      this.billing_addresses = []
      this.choseBillingAddress = null
      this.page = 1
      Object.assign(this.$data.searchForm, this.$options.data().searchForm)
      Object.assign(this.$data.pagination, this.$options.data().pagination)
      if (this.choseRow) {
        this.choseRow.select(false)
        this.choseRow = null
      }
      this.searchBillingAddress()
      this.enableDialog = true
    },
    searchButtonClickEvent () {
      this.billing_addresses = []
      this.page = 1
      this.choseBillingAddress = null
      if (this.choseRow) {
        this.choseRow.select(false)
        this.choseRow = null
      }
      this.searchBillingAddress()
    },
    /**
     * 検索
     */
    searchBillingAddress () {
      let params = {
        code: this.searchForm.code,
        name: this.searchForm.name,
        self_tenant: this.selfTenant,
        page: this.page,
      }
      this.fetchBillingAddressMembers({params: params}).then((content) => {
        this.billing_addresses = content.billing_addresses
        this.pagination = content.pagination
      })
    },
    pageChangeEvent () {
      this.searchBillingAddress()
    },
    /**
     * 行選択イベント
     * @param item
     * @param row
     */
    listRowClick (item, row) {
      this.choseBillingAddress = item
      this.choseBillingAddress.type = 'BillingAddress'
      this.choseRow = row
      row.select(true)
    },
    /**
     * 行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("choseBillingAddressCallback", row.item);
      this.closeDialog()
    },
    /**
     * 反映ボタン クリックイベント
     * 呼び出し元で定義されたコールバックをキックし、選択された請求先情報を返します.
     */
    registerButtonClickEvent () {
      this.$emit('choseBillingAddressCallback', this.choseBillingAddress)
      this.closeDialog()
    },
    /**
     * ダイアログを閉じる
     */
    closeDialog () {
      this.enableDialog = false
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[elements.length - 1].scrollTop = 0;
    },
  }
}
</script>
